module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-apart-1605f2654c6798b6d706aa819670d1ce.svg";